import { render, staticRenderFns } from "./report-zhinengwuzang.vue?vue&type=template&id=a6b5cd54&scoped=true&"
import script from "./report-zhinengwuzang.vue?vue&type=script&lang=ts&"
export * from "./report-zhinengwuzang.vue?vue&type=script&lang=ts&"
import style0 from "./report-zhinengwuzang.vue?vue&type=style&index=0&id=a6b5cd54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b5cd54",
  null
  
)

export default component.exports